import { Component, input } from '@angular/core';

export type PnLogoVariant = 'full' | 'mark' | 'text';

@Component({
    selector: 'pn-logo',
    imports: [],
    templateUrl: './logo.html',
    styleUrl: './logo.scss',
})
export class PnLogo {
    public variant = input<PnLogoVariant>('full');
}
